import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Form } from 'components';
import { FormWrapper } from 'components/Modal/styles';
import ModalForm from 'components/ModalForm/ModalForm';
import { useCreateSize, useUpdateSize } from 'api/products/hooks';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';
import validationSchemas from './schemas';

const SizeForm = ({ type = 'create', initialValues, FormGroup }) => {
  const { t } = useTranslation(['pages', 'app']);
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { mutate: createSize, isPending: isCreating } = useCreateSize();
  const { mutate: updateSize, isPending: isUpdating } = useUpdateSize();
  return (
    <ModalForm
      initialValues={{
        uid: initialValues?.uid || undefined,
        name: initialValues?.name || '',
        region_uid: selectedRegion,
      }}
      onSubmit={({ uid, name }) =>
        type === 'update'
          ? updateSize({ uid, name, region_uid: selectedRegion })
          : createSize({ name, region_uid: selectedRegion })
      }
      validationSchema={validationSchemas.size}
      cancelLabel={t('app:cancel')}
      submitLabel={t(`app:${type}`)}
      pristine
      isLoading={isCreating || isUpdating}
      ignoreClickedState
      isClosePopupOn={false}
    >
      <FormWrapper>
        <FormGroup required label={t('app:name')}>
          <Form.Input type="text" name="name" />
        </FormGroup>
      </FormWrapper>
    </ModalForm>
  );
};

SizeForm.propTypes = {
  type: PropTypes.oneOf(['create', 'update']),
  initialValues: PropTypes.object,
  FormGroup: PropTypes.func,
};

export default SizeForm;
